import { render } from "./SingularActivitiesOverview.vue?vue&type=template&id=86668712"
import script from "./SingularActivitiesOverview.vue?vue&type=script&lang=js"
export * from "./SingularActivitiesOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__